import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";

export default class VistaDatosCiviles extends Component {
  render() {
    let vistaDatosCiviles =
      this.props.DatosProvincia.ministerialRegisterNumber || this.props.DatosProvincia.legalForm ? (
        <Container className="mb-3">
          <Row>
            <Col lg="4" className="border">
              <h6>Número de Registro Ministerial</h6>
              <p>{this.props.DatosProvincia.ministerialRegisterNumber}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Número de Identificación Fiscal</h6>
              <p>{this.props.DatosProvincia.fiscalNumber}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Personalidad Jurídica</h6>
              <p>{this.props.DatosProvincia.legalForm}</p>
            </Col>
          </Row>
        </Container>
      ) : (
        <p className="ml-3">No hay datos actualmente</p>
      );
    return <React.Fragment>{vistaDatosCiviles}</React.Fragment>;
  }
}
